import React, { useEffect } from "react";
import { Box } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Settings from "../views/Settings";
import { useSelector } from "../../store";
import checkRole, { UserRoles } from "../../helpers/checkUserRoles";
import { useNavigate } from "react-router-dom";

interface Props {}

const SettingsPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { dbUser } = useSelector((store) => store.auth);

  useEffect(() => {
    if (!!dbUser) {
      const auth = checkRole(dbUser, UserRoles.GlobalAdmin, true);
      if (!auth) {
        navigate("/apps");
      }
    }
  }, [navigate, dbUser]);

  return (
    <Box>
      <PageTitle title="Company Settings" />
      {checkRole(dbUser!, UserRoles.GlobalAdmin, true) && <Settings />}
    </Box>
  );
};

export default SettingsPage;
